export const Dashboard = "Dashboard";
export const Widgets = "Widgets";
export const Summary = "Summary";
export const NewsUpdate = "News & Update";
export const Appointment = "Appointment";
export const Notification = "notification";
export const MarketValue = "Market Value";
export const Chat = "Chat";
export const Bitcoin = "Bitcoin";
export const FixPrice = "Fix Price";
export const High = "High";
export const BTC = "(BTC)";
export const Amount = "Amount";
export const ProjectType = "Project Type";
export const Hourly = "Hourly";
export const Low = "Low";
export const Priority = "Priority";
export const Urgent = "Urgent";
export const USD = "USD";
export const TUSD = "TUSD";
export const Latest = "Latest";
export const Earlist = "Earlist";
export const Ethereums = "Ethereum";
export const Litecoins = "Litecoin";
export const Projects = "Project";
export const ManageInvoices = "Manage Invoice";
export const CliffordHale = "Clifford Hale";
export const XRP = "(XRP)";
export const Buy = "Buy";
export const Sell = "Sell";
export const Industrys = "Industry";
export const ComputerSoftware = "Computer Software(14)";
export const ITEngineer = "IT Engineer(10)";
export const Serviceindustry = "Service industry(20)";
export const Accountings = "Accounting(34)";
export const FinancialServices = "Financial Services(5)";
export const HTML = "HTML,scss & sass";
export const Javascript = "Javascript";
export const Node = "Node.js";
export const Gulp = "Gulp & Pug";
export const Angular = "Angular.js";
export const Spanish = "Spanish";
export const Portuguese = "Portuguese";
export const French = "French";
export const STEP = 10;
export const MIN = 100;
export const MAX = 950;

export const NewProduct = "New Product";
export const Location = "Location";
export const RiskFactor = "Risk Factor";
export const BestSeller = "Best Seller";

export const Earnings = "Earnings";
export const Products = "Products";
export const Messages = "Messages";
export const Settings = "Settings";
export const NewUser = "New User";

export const New = "New";
export const Pending = "Pending";
export const Done = "Done";
export const Doing = "Doing";
export const Smooth = "Smooth";
export const Running = "Running";
export const Cancel = "Cancel";

export const kolkata_India = "kolkata, India";
export const India_Surat = "India, Surat";
export const RecentActivity = "Recent Activity";
export const Profit = "Profit";
export const Loss = "Loss";
export const MarkJecno = "Mark Jecno";
export const Manager = "Manager";
export const Follower = "Follower";
export const Following = "Following";
export const TotalPost = "Total Post";
export const NewOrder = "New Order";

export const Facebooks = "Facebook";
export const Twitters = "Twitter";
export const Linkedins = "Linkedin";
export const GooglePlus = "Google +";
export const Github = "Github";

export const Daily = "Daily";
export const Weekly = "Weekly";
export const Yearly = "Yearly";
export const Monthly = "Monthly";
export const Hot = "Hot";
export const Date = "Date";
export const Month = "Month";
export const Week = "Week";
export const Time = "Time";
export const Sale = "Sale";
export const Year = "Year";
export const Today = "Today";
export const Day = "Day";
export const JohnLoren = "John Loren";
export const VenterLoren = "Venter Loren";
export const Tomorrow = "Tomorrow";
export const Yesterday = "Yesterday";
export const RightNow = "Right Now";

export const TodayTotalSale = "Today Total sale";
export const TodayTotalVisits = "Today Total visits";
export const OurSaleValue = "Our Sale Value";
export const TodayStockValue = "Today Stock value";
export const TotalProfit = "Total Profit";
export const HikeShoes = "Hike Shoes";
export const CouponCode = "coupon code";
export const TreePot = "Tree Pot";
export const Bag = "Bag";
export const Watch = "Watch";
export const TShirt = "T-shirt";
export const TotalGoal = "Total Goal";
export const GoalArchive = "Goal Archive";
export const DownloadDetails = "Download details";

export const Johnketer = "John keter";
export const HerryVenter = "Herry Venter";
export const LoainDeo = "loain deo";
export const HorenHors = "Horen Hors";
export const InProcess = "In process";
export const FenterJessy = "fenter Jessy";

export const ReferralEarning = "Referral Earning";
export const CashBalance = "Cash Balance";
export const SalesForcasting = "Sales Forcasting";
export const Sales = "Sales";
export const Store = "Store";
export const Online = "Online";

export const SalesReturn = "Sales Return";
export const PurchaseRet = "Purchase Ret";
export const PurchaseOrderValue = "Purchase Order Value";
export const ProductOrderValue = "Product Order Value";

export const ProductsCart = "Products Cart";

export const Details = "Details";
export const Quantity = "Quantity";
export const Status = "Status";
export const Price = "Price";

export const Employee_Status = "Employee Status";
export const Name = "Name";
export const Designation = "Designation";
export const SkillLevel = "Skill Level";
export const Experience = "Experience";

export const ContactUs = "Contact Us";
export const Contact = "Contact";
export const YourName = "Your Name";
export const Email = "Email";
export const Message = "Message";
export const PrivacyPolicy = "Privacy Policy";
export const SEND_IT = "SEND IT";

// dashboard charts

export const SALE = "SALE";
export const PROJECTS = "PROJECTS";
export const PRODUCTS = "PRODUCTS";

export const MarketinExpenses = "Marketing Expenses";
export const TotalSales = "Total sales";
export const TotalPurchase = "Total purchase";
export const TotalEarning = "Total Earning";
export const SkillStatus = "Skill Status";
export const OrderStatus = "Order Status";

export const LiveProducts = "Live Products";
export const Turnover = "Turnover";
export const MonthlySales = "Monthly Sales";

export const Uses = "Uses";
export const BrowserUsess = "Browser Uses";
export const Finance = "Finance";
export const Rejected = "Rejected";
export const InProgress = "In Progress";
export const Browser = "Browser";
export const UsageinBrowser = "Usage in Browser";
export const APRIL = "APRIL";
export const CustomerFeedbacks = "CustomerFeedback";
export const Positive = "Positive";
export const Negative = "Negative";
export const KelvinELedbetter = "Kelvin E. Ledbetter";
export const JohnCarter = "John Carter";
export const RecentActivitys = "Recent Activity";
export const Saledetails = "Sale details";
export const Orderdetails = "Order details";
export const Posts = "Posts";
export const Peris = "Peris";

// Project

export const ProjectTitle = "Project Title";
export const ClientName = "Client name";
export const ProjectRate = "Project Rate";

export const ProgressLevel = "Progress Level";
export const ProjectStatus = "Project Status";
export const ProjectSize = "Project Size";
export const Small = "Small";
export const Medium = "Medium";
export const Big = "Big";

export const StartingDate = "Starting date";
export const EndingDate = "Ending date";
export const EnterSomeDetails = "Enter some Details";
export const UploadProjectFile = "Upload project file";
export const Add = "Add";
export const CreateNewProject = "Create New Project";

export const Issues = "Issues";
export const Resolved = "Resolved";
export const Comment = "Comment";

// ecommerce

export const Filters = "Filters";
export const ShowingProducts = "Showing Products 1 - 24 Of 200 Results";
export const Featured = "Featured";
export const LowestPrices = "Lowest Prices";
export const HighestPrices = "Highest Prices";
export const NotFoundData =
  "Sorry, We didn't find any results matching this search";
export const ProductDetails = "Product Details";
export const AddToCart = "Add to Cart";
export const BuyNow = "Buy Now";
export const ContinueShopping = "continue shopping";
export const ViewDetails = "View Details";
export const OutOfStock = "Out Of Stock";
export const Fulltime = "Full-time (8688)";
export const Contract = "Contract (503)";
export const Parttime = "Part-time (288)";
export const Internship = "Internship (236)";
export const Temporary = "Temporary (146)";
export const Commission = "Commission (25)";

export const ProductSizeArray = ["M", "L", "Xl"];

export const Fusion = "Fusion white & blue printed regular fit asymmetric";
export const ProductReview = "(250 review)";
export const ProductPageDetails =
  "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters,It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters";
export const Febric = "Febric";
export const Brand = "Brand";
export const Availability = "Availability";

export const ProductListTitle = "Individual column searching (text inputs)";
export const ProductListDesc =
  "The searching functionality provided by DataTables is useful for quickly search through the information in the table - however the search is global, and you may wish to present controls that search on specific columns.";

export const CreditCard = "Credit card";
export const DebitCard = "Debit card";
export const ExpirationDate = "Expiration Date";
export const COD = "COD";
export const EMI = "EMI";
export const NetBanking = "Net Banking";
export const Submit = "Submit";

export const SelectMonth = ["Select Month", "Jan", "Fab", "March", "April"];
export const SelectYear = [
  "Select Year",
  "2015",
  "2016",
  "2017",
  "2018",
  "2022",
];
export const BankName = ["Bank Name", "SBI", "ICICI", "KOTAK", "BOB"];
export const SelectCard = ["Select Card", "2", "3", "4", "5"];
export const SelectDuration = [
  "Select Duration",
  "2015-2016",
  "2016-2017",
  "2017-2018",
  "2018-2022",
];

export const ShippedOrders = "Shipped Orders";
export const CancelledOrders = "Cancelled Orders";

export const SimplePricingCard = "Simple Pricing Card";
export const BecomeMember = "Become member";
export const PricingTableWithBorder = "Pricing Table With Border";
export const ColorHighlight = "Color Highlight";
export const PricingTableWithRibbons = "Pricing Table With Ribbons";
export const Standard = "Standard";
export const Business = "Business";
export const Premium = "Premium";
export const Extra = "Extra";
export const Pricings = "Pricing";
export const Popular = "Popular";
export const Subscribe = "Subscribe";
export const LorumIpsum = "Lorum Ipsum";
export const Purchase = "Purchase";

export const CartTitle = "Cart";
export const CartTableHeader = [
  "Product",
  "Product Name",
  "Price",
  "Quantity",
  "Action",
  "Total",
];

export const NewOrders = "New Orders";
export const TotalPrice = "Total Price";
export const CheckOut = "check out";
export const CartEmpty = "Your Cart is Empty";
export const ExploreShortlistItems = "Explore more shortlist some items.";

export const WishlistTitle = "Wishlist";
export const MoveToCarts = "Move to Cart";
export const WishlistTableHeader = [
  "Product",
  "Product Name",
  "Price",
  "Availability",
  "Action",
];

// check out
export const BillingDetails = "Billing Details";
export const FirstName = "First Name";
export const LastName = "Last Name";
export const Phone = "Phone";
export const EmailAddress = "Email Address";
export const Country = "Country";

export const CountryMenu = [
  "India",
  "South Africa",
  "United State",
  "Australia",
];

export const Address = "Address";
export const TownCity = "Town/City";
export const StateCountry = "State/Country";

export const PostalCode = "Postal Code";
export const CheckMeOut = "Check me out";
export const PlaceOrder = "Place Order";

export const Product = "Product";
export const Total = "Total";
export const Subtotal = "Subtotal";

export const Shipping = "Shipping";
export const Option1 = "Option 1";
export const Option2 = "Option 2";
export const CheckPayments = "Check Payments";
export const CashOnDelivery = "Cash On Delivery";
export const PayPal = "PayPal";

// filter
export const Colors = "Colors";
export const NewProducts = "New Products";
export const FancyShirt = "Fancy Shirt";
export const FancyShirtPrice = "$100.00";

// invoice

export const InvoiceHash = "Invoice #";
export const IssuedMay = "Issued: May";
export const PaymentDue = "Payment Due: June";
export const JohanDeo = "Johan Deo";
export const JohanDeoMailId = "JohanDeo@gmail.com";
export const ProjectDescription = "Project Description";
export const ProjectDescriptionDetails =
  "Lorem Ipsum is simply dummy text of the printing and typesetting industry.It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.";
export const ProductName = "Product Name";
export const Sub_total = "Sub-total";
export const ThankBusiness = "Thank you for your business!";
export const ThankBusinessDesc =
  "Payment is expected within 31 days; please process this invoice within that time. There will be a 5% interest charge per month on late invoices.";
export const Print = "Print";

// Users

export const MarekjecnoMailId = "Marekjecno@yahoo.com";
export const BOD = "BOD";
export const DDMMYY = "02 January 1988";
export const Designer = "designer";
export const ContactUsNumber = "India +91 123-456-7890";
export const LocationDetails = "B69 Near Schoool Demo Home";
export const JOHANDIO = "JOHAN DIO";
export const UserProfileDesc1 =
  "you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet.";
export const UserProfileDesc2 =
  "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source .Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source";
export const UserProfileDesc3 =
  "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consecteturContrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur";
export const Like = "Like";

export const MyProfile = "My Profile";
export const Bio = "Bio";
export const City = "City";
export const Password = "Password";
export const Website = "Website";
export const Save = "Save";
export const EditProfile = "Edit Profile";
export const Company = "Company";
export const Username = "Username";
export const UsersCountryMenu = [
  "--Select--",
  "Germany",
  "Canada",
  "Usa",
  "Aus",
];
export const AboutMe = "About Me";
export const UpdateProfile = "Update Profile";
export const UsersTableTitle = "Add projects And Upload";
export const UsersTableHeader = ["Project Name", "Date", "Status", "Price", ""];
export const Edit = "Edit";
export const Update = "Update";
export const Delete = "Delete";

// calendar
export const BasicCalendars = "Basic Calendar";
export const Dragging_Event = "DRAGGING EVENT";

// chats
export const CALL = "CALL";
export const STATUS = "STATUS";
export const PROFILE = "PROFILE";
export const Profile = "Profile";
export const EricaHughes = "Erica Hughes";
export const VincentPorter = "Vincent Porter";
export const Active = "Active";
export const ChataApp_p1 = "Established fact that a reader will be distracted ";
export const ChataApp_p2 = "Dolore magna aliqua ";
export const Send = "SEND";

// email
export const MARKJENCO = "MARK JENCO";
export const MARKJENCOEMAIL = "Markjecno@gmail.com";
export const NEWMAIL = "NEW MAIL";
export const Inbox = "Inbox";
export const AllMail = "All mail";
export const Sent = "Sent";
export const Draft = "Draft";
export const Trash = "Trash";

export const IMPORTANT = "IMPORTANT";
export const Starred = "Starred";
export const UNREAD = "UNREAD";
export const Spam = "Spam";
export const OUTBOX = "OUTBOX";
export const UPDATE = "UPDATE";
export const ALERT = "ALERT";
export const NOTES = "NOTES";
export const NoMailFound = "No mail found";
export const NewMessage = "New Message";
export const SendMessage = "Send Message";
export const To = "To";
export const ATTACHMENTS = "ATTACHMENTS";
export const DownloadAll = "Download All";
export const Reply = "Reply";
export const ReplyAll = "Reply All";
export const Forward = "Forward";
export const More = "More";
export const Subject = "Subject";

// file-manager
export const Hometxt = "Home";
export const API = "API";
export const All = "All";
export const Recent = "Recent";
export const Recovery = "Recovery";
export const Deleteds = "Deleteds";
export const Storage = "Storage";
export const PricingPlan = "Pricing plan";
export const TrialVersion = "Trial Version";
export const FREE = "FREE";
export const Free = "Free";
export const Selected = "Selected";
export const AddNew = "Add New";
export const Upload = "Upload";
export const AllFiles = "All Files";
export const RecentlyOpenedFiles = "Recently opened files";
export const Folders = "Folders";
export const EndlessAdmin = "Endless admin";
export const Files = "Files";

export const CustomBoards = "Custom Board";
export const DefaultDemo = "Default Demo";

// bookmark
export const NewBookmark = "New Bookmark";
export const AddBookmark = "Add Bookmark";
export const EditBookmark = "Edit Bookmark";
export const MyBookmark = " My bookmark";
export const WebUrl = "Web Url";
export const Title = "Title";
export const Description = "Description";
export const Group = "Group";
export const Collection = "Collection";
export const General = "General";
export const MyBookmarks = "My Bookmarks";
export const Views = "Views";
export const CreatedByMe = "Created by me";
export const Favourites = "Favourites";
export const SharedWithMe = "Shared with me";
export const Tags = "Tags";
export const Newsletter = "Newsletter";
export const Holidays = "Holidays";
export const Important = "Important";
export const Orgenization = "Organization";
export const NoBookmarksFound = "No Bookmarks Found.";

// task
export const AddTask = "Add Task";
export const NewTask = "New Task";
export const TaskTitle = "Task Title";
export const TodayTasks = "Today's Tasks";
export const DelayedTasks = "Delayed Tasks";
export const UpcomingTasks = "Upcoming Tasks";
export const ThisWeekTask = "This week tasks";
export const AssignedToMe = "Assigned to me";
export const MyTasks = "My tasks";
export const ThisMonthTasks = "This month tasks";
export const NoTaskDueToday = "No task due today.";
export const NoTasksFound = "No tasks found.";

// social app

export const Timline = "Timline";
export const About = "About";
export const GeneralManager = "general manager";
export const Friends = "Friends";
export const Photos = "Photos";

export const MoreCommnets = "More Commnets";
export const ELANA = "ELANA";
export const JasonBorne = "Jason Borne";
export const AlexendraDhadio = "Alexendra Dhadio";
export const OliviaJon = "Olivia Jon";
export const IssaBell = "Issa Bell";

export const SocialNetworks = "Social Networks";
export const ProfileIntro = "Profile Intro";
export const LatestPhotos = "Latest Photos";
export const FavouriteMusicBands = "Favourite Music Bands";
export const Dribbble = "Dribbble";
export const BuckyBarnes = "Bucky Barnes";
export const SarahLoren = "Sarah Loren";
export const ComerenDiaz = "Comeren Diaz";
export const AndewJon = "Andew Jon";
export const JohnyWaston = "Johny Waston";
export const JohnyWilliam = "Johny William";
export const AnnaMull = "Anna Mull";
export const KarleneLex = "Karlene Lex";
export const VellaChism = "Vella Chism";
export const WaiSchalk = "Wai Schalk";
export const DionCast = "Dion Cast";
export const AddFriend = "Add Friend";
export const Hobbies = "Hobbies";
export const MyPage = "My Page";
export const Likes = "Likes";
export const View = "View";
export const MutualFriends = "Mutual Friends";
export const ActivityFeed = "Activity Feed";
export const ActivityLog = "Activity Log";
export const PortfolioTitle = "Portfolio Title";

// contact
export const ContactHistory = "Contact History";
export const ContactCreated = "Contact Created";
export const NewContacts = "New Contacts";
export const AddContacts = " Add Contact";
export const Age = "Age";
export const Mobile = "Mobile";
export const MobileNo = "Mobile No";
export const Personal = "Personal";
export const AddCategory = "Add Category";
export const FollowUp = "Follow up";
export const Ideas = "Ideas";
export const History = "History";
export const NoDataFound = "No Data Found";
export const Gender = "Gender";
export const Male = "Male";
export const Female = "Female";
export const PrintViews = "Print preview";

// todo
export const ToDo = "To-Do";
export const AddNewTask = "Add new task";
export const Close = "Close";

// UI-KITS
export const DefaultColor = "Default Color";
export const Color = "Color";
export const Primary = "Primary";
export const secondary = "Secondary";
export const Success = "Success";
export const Info = "Info";
export const Warning = "Warning";
export const Information = "Information";
export const Danger = "Danger";
export const Pink = "Pink";
export const Grey = "Grey";
export const Dark = "Dark";
export const Light = "Light";

export const Headings = "Headings";
export const SubHeading = "Sub Heading";
export const Heading1 = "Heading 1";
export const Heading2 = "Heading 2";
export const Heading3 = "Heading 3";
export const Heading4 = "Heading 4";
export const Heading5 = "Heading 5";
export const Heading6 = "Heading 6";
export const VeryThin100 = "Very Thin (100)";
export const Thin300 = "Thin (300)";
export const Normal400 = "Normal (400)";
export const LightNormal600 = "light Normal (600)";
export const Bold700 = "Bold (700)";
export const ExtraBold900 = "Extra Bold (900)";
export const DisplayHeadings = "Display headings";
export const TextColor = "Text Color";
export const ListingTypography = "Listing Typography";
export const UnorderList = "Unorder list";
export const OrderList = "Order list";
export const FontawesomeList = "Fontawesome list";
export const ICOIconList = "ICO Icon list";
export const ThemifyList = "Themify list";
export const Blockquotes = "Blockquotes";
export const SourceTitle = "Source Title";

export const Sizing = "Sizing";
export const StatusIndicator = "Status Indicator";
export const Initials = "Initials";
export const Shape = "Shape";
export const Ratio = "Ratio";
export const Groups = "Groups";

export const Padding = "Padding";
export const Margins = "Margins";
export const PaddingLeft = "Padding Left";
export const PaddingRight = "Padding Right";
export const PaddingTop = "Padding Top";
export const PaddingBottom = "Padding Bottom";
export const MarginLeft = "Margin Left";
export const MarginRight = "Margin Right";
export const MarginTop = "Margin Top";
export const MarginBottom = "Margin Bottom";
export const VerticalAlign = "Vertical Align";
export const ImageSizes = "Image Sizes";
export const BadgeColor = "Badge Color";
export const BackgroundColor = "Background Color";
export const ButtonColor = "Button Color";
export const BorderRadius = "Border Radius";
export const FontWeight = "Font Weight";
export const FontStyle = "Font Style";
export const Float = "Float";
export const Overflow = "Overflow";
export const FontSize = "Font Size";
export const AllBordersColor = "All Borders Color";
export const BorderWidth = "Border Width";
export const Position = "Position";
export const ButtonOutline = "Button Outline";

export const GridOptions = "Grid Options";
export const ExtraSmall = "Extra small";
export const Large = "Large";
export const ExtraLarge = "Extra large";
export const ExtraextraLarge = "Extra large";
export const GridBehavior = "Grid behavior";
export const GutterWidth = "Gutter width";
export const Nestable = "Nestable";
export const Offsets = "Offsets";
export const ColumnOrdering = "Column ordering";
export const GridColumn = "Grid Column";
export const VerticalAlignment = "Vertical alignment";
export const HorizontalAlignment = "Horizontal alignment";
export const NestingColumn = "Nesting Column";
export const Order = "Order";

export const ContextualVariations = "Contextual variations";
export const TagsWithNumber = "Tags with number";
export const PillsWithNumber = "Pills with number";
export const TagsWithIcon = "Tags With icon";
export const PillsWithIcon = "Pills with Icon";
export const BadgesExample = "Badges Example";

export const BasicProgressBars = "Basic Progress Bars";
export const SmallProgressBars = "Small Progress Bars";
export const LargeProgressBars = "Large Progress Bars";
export const CustomHeightProgressBars = "Custom Height Progress Bars";
export const ProgressBarsStates = "Progress Bars states";
export const MultipleBars = "Multiple bars";
export const ProgressBarsStriped = "Progress Bars Striped";
export const ProgressBarsAnimated = "Progress Bars animated";

export const StaticExample = "Static Example";
export const BasicModal = "Basic Modal";
export const Simple = "Simple";
export const ModalTitle = "Modal title";
export const SaveChanges = "Save changes";
export const ScrollingLongContent = "Scrolling long content";
export const VerticallyCentered = "Vertically centered";
export const TooltipsAndPopovers = "Tooltips and popovers";
export const UsingTheGrid = "Using the grid";
export const VaryingModalContent = "Varying modal content";
export const SizesModal = "Sizes modal";
export const LargeModal = "Large modal";
export const SmallModal = "Small modal";

export const AlertWithIcon = "Alert With Icon";
export const LightAlerts = "Light Alerts";
export const LinkColor = "Link color";
export const Dismissing = "Dismissing";
export const OutlineAlerts = "Outline Alerts";
export const OutlineDarkAlerts = "Outline Dark Alerts";
export const AlertWithIconOutline = "Alert With Icon outline";
export const AlertWithIconInverse = "Alert With Icon inverse";
export const AdditionalContent = "Additional content";
export const TextAsAction = "Text as action";

export const BasicExamples = "Basic Examples";
export const Direction = "Direction";
export const HTMLContent = "HTML Content";
export const OffsetToTooltip = "Offset to Tooltip";

export const WithTitleAlert = "With Title alert";
export const SuccessAlert = "Success alert";
export const InfoAlert = "Info alert";
export const WarningAlert = "Info alert";
export const Basic = "Basic";

export const BasicTooltip = "Basic Tooltip";
export const HoverMe = "Hover Me";
export const PopoverTitle = "Popover title";
export const HTMLElements = "HTML elements";

export const LoaderStyle = "Loader Style";

export const BasicDropdown = "Basic Dropdown";
export const DropdownButton = "Dropdown Button";
export const Action = "Action";
export const AnotherAction = "Another Action";
export const AnotherLink = "Another Link";
export const SomethingElseHere = "Something Else Here";
export const BasicColorDropdown = "Basic Color Dropdown";
export const DropdownSplitButton = "Dropdown Split Button";
export const RoundedDropdown = "Rounded Dropdown";
export const DropdownWithDivider = "Dropdown With Divider";
export const DropdownWithHeader = "Dropdown With Header";
export const DropdownWithDisable = "Dropdown With Disable";
export const DropdownWithDropUp = "Dropdown With DropUp";
export const Normal = "Normal";
export const Disabled = "Disabled";
export const DropdownHeader = "Dropdown Header";

export const BasicAccordion = "Basic Accordion";
export const CollapsibleGroupItem = "Collapsible Group Item #";
export const AllCloseAccordion = "All Close Accordion";
export const ColorAccordion = "Color Accordion";
export const AccordionWithIconOnTitle = "Accordion With Icon on Title";
export const AccordionOpenCloseIcon = "Accordion open close icon";

export const BasicTabs = "Basic Tabs";
export const TabsBottomLeftAlign = "Tabs bottom left Align";
export const TabsWithIcon = "Tabs With Icon";
export const TabsRightAlign = "Tabs Right Align";
export const TabsVertical = "Tabs Vertical";
export const PillTabs = "Pill Tabs";
export const PillTabsWithIcon = "Pill Tabs With Icon";
export const PillDarkColor = "Pill Dark color";
export const PrimaryColor = "Primary Color";
export const SecondaryColor = "Secondary Color";
export const SuccessColor = "Success Color";
export const InfoColor = "Info Color";
export const WarningColor = "Warning Color";
export const DangerColor = "Danger Color";

export const SimpleMaterialTab = "Simple Material style tab";
export const MaterialBottomTab = "Material style bottom tab";
export const MaterialLeftTab = "Material style left tab";
export const MaterialRightTab = "Material style right tab";
export const MaterialColorTab = "Material color tab";

export const DefaultNav = "Default Nav";
export const Base = "Base";
export const Forms = "Forms";
export const Tables = "Tables";
export const DropdownExample = "Dropdown example";

export const ItemBullets = "Item Bullets";
export const SectionAndSeparator = "Section and Separator";
export const Layouts = "Layout";
export const Sidebars = "Sidebar";
export const Charts = "Charts";
export const Maps = "Maps";
export const Audios = "Audios";
export const Editors = "Editors";
export const TreeView = "TreeView";
export const Rating = "Rating";
export const Scrollable = "Scrollable";
export const Advance = "Advance";
export const Timeline = "Timeline";
export const Cards = "Cards";
export const PageLayout = "Page Layout";
export const Footers = "Footers";
export const LogOut = "Log Out";
export const ActiveAndDisabledLinks = "Active and Disabled Links";
export const InlineNav = "Inline Nav";
export const SubNav = "Sub Nav";
export const StaticSubNav = "Static Sub Nav";
export const ToggleSubNav = "Toggle Sub Nav";
export const Panding = "Panding";
export const Replied = "Replied";

export const Examples = "Examples";
export const LargerShadow = "Larger shadow";
export const RegularShadow = "Regular shadow";
export const SmallShadow = "Small shadow";
export const NoShadow = "No shadow";

export const DefaultList = "Default List";
export const LinksAndButtons = "Links and buttons";
export const FlushStyle = "Flush Style";
export const ContextualClasses = "Contextual classes";
export const WithBadges = "With badges";
export const CustomContent = "Custom content";
export const JavaScriptBehavior = "JavaScript behavior";
export const WithIcon = "With Icon";
export const WithImages = "With Images";
export const WithImageRounded = "With Image Rounded";

// bonus ui
export const VerticalScrollbar = "Vertical Scrollbar";
export const ClickAndDragScrollbar = "Click and Drag Scrollbar";
export const SmoothScrollbar = "Smooth Scrollbar";
export const NoScrollbar = "No Scrollbar";

export const CustomDirections = "Custom  Directions";
export const CustomAutoclose = "Custom Autoclose";

export const StarRating = "Star Rating";
export const HeartRating = "Heart Rating";
export const ThumbsUpDownRating = "Thumbs Up/Down Rating";
export const PillRating = "Pill Rating";

export const SingleFileUpload = "Single File Upload";
export const MultiImageUpload = "Multi only Image Upload";
export const MultipleImageVideoAudioUpload =
  "Multiple Image Video Audio Upload";
export const LimitationFileUpload = "Limitation File Upload";
export const CustomFileUpload = "Custom File Upload";

export const AdvancedState = "Advanced State";
export const AlertState = "Alert State";

export const Carousel = "Carousel";
export const UncontrolledCarousel = "Uncontrolled Carousel";
export const CarouselClassname = "Carousel Using a Tag And Classname";

export const SuccessNotification = "Success Notification";
export const InfoNotification = "Info Notification";
export const WarningNotification = "Warning Notification";
export const DangerNotification = "Danger Notification";
export const TopCenter = "Top Center";
export const BottomCenter = "Bottom Center";
export const BottomLeft = "Bottom Left";
export const RightBottom = "Right Bottom";
export const AutoCloseIn15000Sec = "AutoClose in 15000 Sec";
export const AutoCloseIn5000Sec = "AutoClose in 5000 Sec";
export const AutoCloseIn1000Sec = "AutoClose in 1000 Sec";
export const AutoCloseIn500Sec = "AutoClose in 500 Sec";

export const ColoredBreadcrumb = "Colored Ribbons";
export const Ribbon = "Ribbon";

export const Pagi_Nations = "Pagination";
export const PaginationWithIcons = "Pagination with icons";
export const PaginationAlignment = "Pagination alignment";
export const PaginationActiveDisabled = "Pagination with active and disabled";
export const PaginationColor = "Pagination Color";
export const PaginationSizing = "Pagination sizing";
export const Previous = "Previous";
export const Next = "Next";

export const Default_Step = "Default Step";
export const Step_With_Icon = "Step with icon";
export const Step_States = "Step States";
export const Step_Sizing = "Step Sizing";
export const Vertical_Step = "Vertical Step";
export const Default_Pearls_Steps = "Default Pearls Steps";
export const Pearls_Steps_Icon = "Pearls Steps with icon";
export const Pearls_Step_Sizing = "Pearls Step Sizing";
export const Pearls_Step_States = "Pearls Step States";

export const DefaultBootstrapBreadcrumb = "Default bootstrap breadcrumb";
export const NavBreadcrumb = "Nav breadcrumb";
export const Library = "Library";
export const Data = "Data";
export const Bootstrap = "Bootstrap";

export const BasicSlider = "Basic Slider";
export const Default = "Default";
export const NegativeValues = "Negative Values";
export const FormatedLabel = "Formated Label";
export const DraggableRange = "Draggable Range";

export const ImageCropper = "Image Cropper";
export const StickyNote = "Sticky Note";
export const AddNewNote = "Add New Note";

export const ClickAndDrag = "Click And Drag";
export const SpillDragNDrop = "Spill Drag N Drop";
export const CopyDragNDrop = "Copy Drag N Drop";

export const MultipleImageUpload = "Multiple Image Upload";
export const SelectSingleImageUpload = "Select Single Image Upload";

export const BasicCard = "Basic Card";
export const FlatCard = "Flat Card";
export const WithoutShadowCard = "Without shadow Card";
export const IconInHeading = "Icon in Heading";
export const CardSubTitle = "Card sub Title";
export const CardWithFooter = "Card With Footer";
export const Card_Footer = "Card Footer";
export const PrimaryColorCard = "Primary Color Card";
export const SecondaryColorCard = "Secondary Color Card";
export const SuccessColorCard = "Success Color Card";
export const PrimaryColorHeader = "Primary Color Header";
export const PrimaryColorBody = "Primary Color Body";
export const PrimaryColorFooter = "Primary Color Footer";

export const BorderLeft = "Border left";
export const BorderRight = "Border right";
export const BorderTop = "Border top";
export const BorderBottom = "Border bottom";
export const BorderColorState = "Border color state";
export const AbsoluteStyle = "Absolute Style";
export const ColorState = "Color state";

export const SimpleTab = "Simple Tab";
export const ColorTab = "Color Tab";
export const ColorOption = "Color Option";
export const MaterialTabWithColor = "Material Tab With Color";
export const MaterialTabWithIcon = "Material Tab With Icon ";

export const DragBothTitleCard = "Drag Both Title and card";
export const DragOnlyCard = "Drag only card";
export const DragOnlyContent = " Drag only Content";

export const TimelinePrimaryColor = "Timeline Primary color";
export const NewSale = "New Sale";
export const NewReport = "New Report";
export const NewVisits = "New Visits";
export const TimelineSecondaryColor = "Timeline secondary color";
export const TimelineSuccessColor = "Timeline Success color";
export const TimelineInfoColor = "Timeline Info color";
export const TimelineWarningColor = "Timeline Warning color";
export const TimelineDangerColor = "Timeline Danger color";

export const FlagIcons = "Flag Icons";
export const Currency = "Currency";
export const Icons = "Icons";
export const WebApp = "Web App";
export const Spinner = "Spinner";
export const FormControl = "Form Control";
export const TextEditor = "Text Editor";
export const Directional = "Directional";

export const VideoPlayer = "Video Player";
export const BrandPlayer = "Brand Player";
export const MedicalPlayer = "Medical Player";

export const Abstract = "Abstract";
export const Animal = "Animal";
export const Construction = "Construction";
export const Device = "Device";
export const Education = "Education";
export const Emotion = "Emotion";
export const FileType = "File Type";
export const Food = "Food";
export const KidsToys = "Kids & Toys";
export const Law = "Law";
export const Mathematical = "Mathematical";
export const Medical = "Medical";
export const MobileUI = "Mobile UI";
export const Multimedia = "Multimedia";
export const Payment = "Payment";
export const Person = "Person";
export const Search = "Search";
export const Social = "Social";
export const Sport = "Sport";
export const Transport = "Transport";
export const Travel = "Travel";
export const Weather = "Weather";
export const WebApplication = "Web Application";

export const ArrowsDirection = "Arrows & Direction";
export const Control = "Control";

export const Feather = "Feather";
export const WhetherIconsWithAnimations = "Whether Icons With Animations";

export const SimpleLineIcons = "Simple-Line Icons";
export const TypiconsIcons = "typicons Icons";
export const Pe7Icons = "pe7 Icons";
export const IonicIcons = "ionic Icons";

export const DefaultButtons = "Default buttons";
export const BootstrapStateButtons = "Bootstrap state buttons";
export const PrimaryButton = "Primary Button";
export const SecondaryButton = "Secondary Button";
export const SuccessButton = "Success Button";
export const InfoButton = "Info Button";
export const WarningButton = "Warning Button";
export const DangerButton = "Danger Button";
export const LightButton = "Light Button";
export const LargeButtons = "Large buttons";
export const SmallButtons = "Small buttons";
export const ExtraSmallButtons = "Extra Small buttons";
export const ActiveButtons = "Active Buttons";
export const DisabledButtons = "Disabled buttons";
export const CustomStateButtons = "Custom state buttons";
export const OutlineButtons = "outline buttons";
export const BoldBorderOutlineButtons = "bold Border outline buttons";
export const OutlineLargeButtons = "outline Large buttons";
export const OutlineSmallButtons = "outline small buttons";
export const OutlineExtraSmallButtons = "Outline extra small buttons";
export const DisabledOutlineButtons = "Disabled outline buttons";
export const GradienButtons = "Gradien buttons";

export const BasicButtonGroup = "Basic button group";
export const EdgesButtonGroup = "Edges button group";
export const FlatButtonGroup = "Flat button group";
export const LargeButtonGroup = "large Button group";
export const LargeEdgesButtonGroup = "large Edges Button group";
export const OutlineCustomButtonGroup = "Outline Custom button group";
export const OutlineButtonGroup = "Outline button group";
export const OutlineEdgesButton = "Outline Edges button";
export const OutlineFlatButton = "Outline flat button";
export const RadioButtonGroup = "Radio button group";
export const CheckBoxButtonGroup = "Check Box button group";
export const Nesting = "Nesting";
export const Vertical = "Vertical";
export const Left = "Left";
export const Middle = "Middle";
export const Right = "Right";

export const BasicAreaChart = "Basic Area Chart";
export const AreaSpalineChart = "Area Spaline Chart";
export const BarChart = "Bar chart";
export const ColumnChart = "Column Chart";
export const BubbleChart = "3d Bubble Chart";
export const SteplineChart = "Stepline Chart";
export const PieChart = "Pie Chart";
export const DonutChart = "Donut Chart";
export const MixedChart = "Mixed Chart";
export const CandlestickChart = "Candlestick Chart";
export const RadarChart = "Radar Chart";
export const RadialBarChart = "Radial Bar Chart";

export const RotatingPieChart = "Rotating A Pie Chart";
export const SliceVisibilityThreshold = "Slice Visibility Threshold";
export const StackingAreaChart = "Stacking Area Chart";
export const AreaChart = "Area Chart";
export const BasicBarChart = "Basic bar Chart";
export const MaterialDesign = "Material Design";
export const GanttChart = "Gantt Chart";
export const ComboChart = "ComboChart";
export const BarChart2 = "bar-chart2";
export const WordTree = "Word tree";
export const LineChart = "Line Chart";

export const LineChart2 = "Line Chart-2 Chart";
export const PolarChart = "Polar Chart";
export const DoughnutChart = "Doughnut Chart";

export const AdvancedSMILAnimations = "Advanced SMIL Animations";
export const SVGPathAnimation = "SVG Path animation";
export const AnimatingDonutWithSvg = "Animating a Donut with Svg.animate";
export const BipolarLine = "Bi-polar Line chart with area only";
export const LineChartWithArea = "Line chart with area";
export const BipolarBarChart = "Bi-polar bar chart";
export const StackedBarChart = "Stacked bar chart";
export const HorizontalBarChart = "Horizontal bar chart";
export const ExtremeResponsiveConfiguration =
  "Extreme responsive configuration";
export const SimpleLineChart = "Simple line chart";
export const HolesInData = "Holes in data";
export const FilledHolesInData = "Filled holes in data";

export const AngleOffset = "Angle Offset";
export const DisableDisplayInput = "Disable Display Input";
export const CursorMode = "Cursor Mode";
export const DisplayPreviousValue = "Display Previous Value";
export const AngleOffsetArc = "Angle Offset & Arc";

// forms
export const CustomStyles = "Custom styles";
export const BrowserDefaults = "Browser defaults";
export const SupportedElements = "Supported elements";
export const Tooltips = "Tooltips";
export const Zip = "Zip";
export const State = "State";
export const SubmitForm = "Submit form";

export const BasicFormControl = "Basic form control";
export const ExampleSelect = "Example select";
export const ExampleMultipleSelect = "Example multiple select";
export const ExampleTextarea = "Example textarea";
export const BasicHTMLInputControl = "Basic HTML input control";
export const SimpleInput = "Simple Input";
export const Placeholder = "Placeholder";
export const Number = "Number";
export const Telephone = "Telephone";
export const URL = "URL";
export const DateAndTime = "Date and time";
export const ColorPicker = "Color picker";
export const MaximumLength = "Maximum Length";
export const StaticText = "Static Text";
export const EdgesInputStyle = "Edges input style";
export const FlatInputStyle = "Flat input style";
export const RaiseInputStyle = "Raise input style";
export const SolidInputStyle = "Solid input style";
export const InputSizing = "Input sizing";
export const SmallSelect = "Small select";
export const LargeSelect = "Large select";
export const DefaultSelect = "Default select";
export const DefaultInput = "Default input";

export const CustomControls = "Custom controls";
export const UploadFile = "Upload File";
export const CustomSelect = "Custom select";
export const LargeInput = "Large Input";
export const SmallInput = "Small Input";
export const Textarea = "Textarea";

export const CustomRadio = "Custom Radio";
export const Option = "Option";
export const Checked = "Checked";
export const RadioStates = "Radio states";
export const InlineCheckbox = "Inline checkbox";
export const CustomCheckbox = "Custom checkbox";
export const CheckboxStates = "Checkbox states";
export const SuccessState = "Success state";
export const BrandState = "Brand state";
export const PrimaryState = "primary state";
export const AnimatedRadioButtons = "Animated radio buttons";
export const AnimatedCheckboxButtons = "Animated checkbox buttons";
export const SquareCheckbox = "Square checkbox";
export const SolidCheckbox = "Solid checkbox";

export const BasicInputGroups = "Basic Input groups";
export const LeftAddon = "Left Addon";
export const RightAddon = "Right Addon";
export const JointAddon = "Joint Addon";
export const LeftRightAddon = "Left & Right Addon";
export const SolidStyle = "Solid style";
export const SquareStyle = "Square style";
export const RaiseStyle = "Raise style";
export const FlatStyle = "Flat style";

export const DefaultStyle = "Default Style";
export const Fast = "Fast";
export const NoBorder = "No Border";
export const SolidBorderStyle = "Solid Border Style";
export const OfferStyleBorder = "Offer style Border";
export const InlineStyle = "Inline Style";
export const Local = "Local";
export const VerticalStyle = "Vertical Style";
export const DeliveryOption = "Delivery Option";
export const BuyingOption = "Buying Option";
export const XYZSeller = "XYZ Seller";
export const ABCSeller = "ABC Seller";
export const HorizontalStyle = "Horizontal Style";

export const DatePickers = "Date Picker";
export const SelectDateWithTime = "Select Date with Time";
export const SelectTimeOnly = "Select Time Only";
export const CustomDateFormat = "Custom date format";
export const TodayButton = "Today button";
export const DisableDaysOfWeek = "Disable days of week";
export const SpecificDateRange = "Specific date range";
export const MinDate = "Min date";
export const MaxDate = "Max date";
export const DateRange = "Date Range";
export const DisableDatepicker = "Disable Datepicker";
export const InlineVersion = "Inline version";

export const TimePickerDarkTheme = "Time Picker with Dark Theme";
export const SetClassicTheme = "Set Classic Theme";
export const SetMultipleTimepicker = "Set Multiple Timepicker";

export const BasicDemo = "Basic Demo";
export const MultipleSelections = "Checked";
export const CustomSelections = "Custom Selections";
export const Remote = "Remote";

export const DefaultFormLayout = "Default Form Layout";
export const HorizontalFormLayout = "Horizontal Form Layout";
export const MegaForm = "Mega form";
export const AccountInformation = "Account Information";
export const CompanyInformation = "Company Information";
export const BillingInformation = "Billing Information";
export const InlineForm = "Inline Form";
export const InlineFormWithLabel = "Inline Form with Label";
export const InlineFormWithoutLabel = "Inline Form without Label";

export const Login = "Login";
export const LOGIN = "LOGIN";
export const CompanyName = "Company Name";
export const ContactNumber = "Contact Number";
export const Radios = "Radios";
export const Checkboxes = "Checkboxes";

export const FormWizardWithIcon = "Form Wizard With Icon";
export const ConfirmPassword = "Confirm Password";
export const DD = "DD";
export const MM = "MM";
export const YY = "YY";

//  tables
export const BasicTable = "Basic Table";
export const InverseTable = "Inverse Table";
export const InverseTablePrimaryBackground =
  "Inverse Table with Primary background";
export const HoverableRows = "Hoverable rows";
export const TextBackgroundUtilities = "Text or background utilities";
export const TableHeadOptions = "Table head options";
export const StripedRow = "Striped Row";
export const StripedRowInverseTable = "Striped Row with Inverse Table";
export const Caption = "Caption";
export const ResponsiveTables = "Responsive Tables";
export const BreckpointSpecific = "Breckpoint Specific";

export const ExtraLargeTables = "Extra Large Tables";
export const LargeTable = "Large Table";
export const DefaultTable = "Default Table";
export const SmallTable = "Small table";
export const ExtraSmallTable = "Extra Small table";
export const HorizontalBorders = "Horizontal Borders";
export const VerticalBorders = "Vertical Borders";
export const BothBordeds = "Both Bordeds";
export const BorderlessTable = "Borderless Table";
export const DefaultTableBorder = "Default Table Border";
export const SolidBorder = "Solid Border";
export const DoubleBorder = "Double Border";
export const DottedBorder = "Dotted Border";
export const DashedBorder = "Dashed Border";
export const BorderBottomColor = "Border Bottom Color";
export const DefultStyling = "Defult Styling";
export const TableFooterStyling = "Table Footer Styling";
export const TableHeadOptionsPrimaryBackground =
  "Table head options With Primary Background";
export const CustomTableColor = "Custom Table Color";
export const CustomTableColorHoverStripped =
  "Custom Table Color with Hover and Stripped";

// pages
export const RememberPassword = "Remember password";
export const ForgotPassword = "Forgot password?";
export const SignIn = "Sign In";
export const SignUp = "Sign Up";
export const CreateAccount = "Create Account";

export const EnterPassword = "Enter your Password";
export const Unlock = "Unlock";
export const CREATEPASSWORD = "CREATE YOUR PASSWORD";
export const RetypePassword = "Retype Password";
export const NewPassword = "New Password";

export const ResetPassword = "Reset Your Password";
export const EnterMobileNumber = "Enter Your Mobile Number";
export const EnterOTP = "Enter OTP";
export const Resend = "Resend";
export const MAINTENANCE = "MAINTENANCE";
export const BACK_TO_HOME_PAGE = "BACK TO HOME PAGE";
export const WE_ARE_COMING_SOON = "WE ARE COMING SOON";

export const SampleCard = "Sample Card";
export const Videos = "Videos";
export const Images = "Images";
export const SearchSetting = "Search setting";
export const Language = "Language";
export const Shopping = "Shopping";
export const Billing = "Billing";
export const Getting = "Getting";
export const Flights = "Flights";
export const Tools = "Tools";

// gallery
export const IMAGE_GALLERY = "IMAGE GALLERY";
export const HoverEffect = "Hover Effect";
export const MasonryGalleryWithDescription = "Masonry Gallery With Description";
export const MasonryGallery = "Masonry Gallery";

// blog
export const JolioMark = "Jolio Mark";
export const PostEdit = "Post Edit";
export const Type = "Type";
export const Text = "Text";
export const Image = "Image";
export const Audio = "Audio";
export const Video = "Video";
export const Category = "Category";
export const Content = "Content";
export const Post = "Post";
export const Discard = "Discard";

// job search
export const UIDesigner = "UI Designer";
export const CreativeTelecom = "Creative Telecom && Technologies , NY";

export const PersonalDetails = "Personal Details";
export const FullName = "Full Name";
export const RepeatPassword = "Repeat Password";
export const BirthDate = "Birth Date";
export const PhoneNumber = "Phone Number";
export const CollegeName = "College Name";
export const Period = "Period";
export const DegreeLevel = "Degree Level";
export const Specialization = "Specialization";
export const YourExperience = "Your Experience";
export const YourEducation = "Your Education";
export const UploadCoverLetter = "Upload Cover Letter";
export const UploadYourCV = "Upload Your CV";
export const UploadRecommendations = "Upload Recommendations";
export const UploadYourFiles = "Upload Your Files";

export const CreativeUnitedStates = "Creative - United States";
export const Qualifications = "Qualifications";
export const AgencyExperience = "Period";
export const Perks = "Perks";
export const SimilarJobs = "Similar jobs";
export const SeniorUXDesigner = "Senior UX designer";
export const Share = "Share";

export const FrontEndWebDeveloper = "Front end web developer";
export const GraphicDesigner = "Graphic designer";
export const DesignerCRM = "Designer, CRM";
export const UIDesigner_E_commerce = "UI designer E-commerce";
export const ReactandReact_Native_Developer = "React/React Native Developer";
export const UIandUX_IT_Frontend_Developer = "UI/UX IT Frontend Developer";

export const FindJobs = "Find jobs";
export const NewYork = "New York";
export const SanFrancisco = "San Francisco";
export const Washington = "Washington";
export const Seattle = "Seattle";
export const Chicago = "Chicago";
export const AllLocations = "All Locations";
export const AllJobTitle = "All Job Title";
export const JobTitle = "Job Title";
export const Industry = "Industry";
export const AllIndustries = "All Industries";
export const SpecificSkills = "Specific skills";
export const AllSkills = "All Skills";
export const JobDescriptions = "JobDescription";
export const Savethisjob = "Save this job";
export const KnowledgeCategories = "Knowledge Categories";
export const Knowledgefilter = "Knowledge filter";

export const FindCourse = "Find Course";
export const Categories = "Categories";
export const Accounting = "Accounting";
export const Design = "Design";
export const Development = "Development";
export const Management = "Management";
export const Duration = "Duration";
export const AllCourses = "All Courses";
export const PaidCourses = "Paid Courses";
export const FreeCourses = "Free Courses";
export const Registration = "Registration";
export const Progress = "Progress";
export const Completed = "Completed";
export const Filter = "Filter";
export const UIDesign = "UI Design";
export const UXDesign = "UX Design";
export const InterfaceDesign = "Interface Design";
export const UserExperience = "User Experience";
export const FrontendDevelopment = "Frontend Development";
export const BackendDevelopment = "Backend Development";
export const UpcomingCourses = "Upcoming Courses";
export const UXDevelopment = "UX Development";
export const BusinessAnalyst = "Business Analyst";
export const WebDevelopment = "Web Development";
export const CourseBy = "Course By";
export const JavaLanguage = "Java Language";

// maps
export const CurrentLocation = "Current Location";
export const MarkerMap = "Marker Map";
export const Polygons = "POLYGONS";
export const Polylines = "Polyline";

export const GeoJsonMapDemo = "GeoJsonMap Demo";
export const AnimateMap = "Animate Map";
export const AnimatePanning = "Animate panning";
export const SetMarkerWithPopup = "Set Marker with Popup";

// editors
export const CKEditorExample = "CK Editor Example";
export const JavascriptMode = "Javascript Mode";
export const HtmlMode = "Html Mode";
export const CssMode = "css Mode";
export const PhpMode = "php Mode";
export const MDEEditorExample = "MDE Editor Example";

// faq anf knowledgebase
export const Articles = "Articles";
export const Knowledgebase = "Knowledgebase";
export const Support = "Support";
export const IntellectualProperty = "Intellectual Property";
export const SellingAndBuying = "Selling And Buying";
export const UserAccounts = "User Accounts";
export const SearchArticles = "Search articles";
export const Navigation = "Navigation";
export const LatestUpdates = "Latest Updates";

export const DavidLinner = "David Linner";
export const UserChristopher = "User Christopher";
export const AskQuestion = "Ask Question";
export const Tutorials = "Tutorials";
export const HelpCenter = "Help center";
export const VideoTutorials = "Video Tutorials";

export const AskOurCommunity = "Ask our community";
export const VictoriaWilson = "Victoria Wilson";
export const FeaturedTutorials = "Featured Tutorials";
export const WebDesign = "Web Design";
export const SeeAll = "See All";
export const BrowseArticles = "Browse Articles";

// layout
export const Loading = "Loading...";
export const BonusUi = "Bonus Ui";
export const MegaMenu = "Mega menu";
export const ErrorPage = "Error Page";
export const Authentication = "Authentication";
export const UsefullPages = "Usefull Pages";
export const ComingSoon = "Coming Soon";

export const English = "English";
export const Deutsch = "Deutsch";
export const Español = "Español";
export const Français = "Français";
export const Português = "Português";
export const 简体中文 = "简体中文";
export const DeliveryProcessing = "Delivery processing";
export const OrderComplete = "Order Complete";
export const TicketsGenerated = "Tickets Generated";
export const DeliveryComplete = "Delivery Complete";
export const CheckAllNotification = "Check all notification";
export const ShopingBag = "Shoping Bag";
export const OrderTotal = "Order Total";
export const GoToShopingBag = "Go to shoping bag";

export const ViewCart = "View Cart";
export const MessageBox = "Message Box";
export const KoriThomas = "Kori Thomas";
export const AinChavez = "Ain Chavez";
export const ViewAll = "View All";
export const Admin = "Admin";
export const Account = "Account";
export const Taskboard = "Taskboard";

export const QuickOption = "Quick option";
export const Document = "Document";
export const CheckFeatures = "Check features";
export const UnlimitedColor = "Unlimited Color";
export const Apply = "Apply";
export const Customizer = "Customizer";
export const Customize = "Customize";
export const PreviewRealTime = "Preview Real Time";
export const Configuration = "Configuration";
export const CopyText = "Copy text";
export const LayoutType = "Layout Type";
export const LTR = "LTR";
export const RTL = "RTL";
export const Box = "Box";
export const SidebarType = "Sidebar Type";
export const SidebarSettings = "Sidebar settings";
export const Border = "Border";
export const IconColor = "icon Color";

export const RouterAnimation = "Router Animation";
export const ZoomFade = "Zoom Fade";
export const SildeFade = "Silde Fade";
export const FadeBottom = "Fade Bottom";
export const Fade = "Fade";
export const ZoomOut = "Zoom Out";
export const None = "None";
export const LightLayout = "Light layout";
export const DarkLayout = "Dark Layout";
export const MixLayout = "Mix Layout";

export const LevelMenu = "Level Menu";
export const FileManager = "File manager";
export const UserProfile = "User Profile";
export const UserEdit = "User Edit";
export const UsersCards = "Users Cards";
export const KanbanBoard = "Kanban Board";
export const SocialApp = "Social App";
export const Bookmark = "Bookmark";
export const AddNewBookmark = "Add New Bookmark";
export const Back = "Back";

// All 195 Nationalities (Adjective forms)
export const NATIONALITIES = [
  { value: "AF", name: "أفغاني" },
  { value: "AL", name: "ألباني" },
  { value: "DZ", name: "جزائري" },
  { value: "AD", name: "أندوري" },
  { value: "AO", name: "أنغولي" },
  { value: "AG", name: "أنتيغوي" },
  { value: "AR", name: "أرجنتيني" },
  { value: "AM", name: "أرميني" },
  { value: "AU", name: "أسترالي" },
  { value: "AT", name: "نمساوي" },
  { value: "AZ", name: "أذربيجاني" },
  { value: "BS", name: "بهامي" },
  { value: "BH", name: "بحريني" },
  { value: "BD", name: "بنغلاديشي" },
  { value: "BB", name: "بربادوسي" },
  { value: "BY", name: "بيلاروسي" },
  { value: "BE", name: "بلجيكي" },
  { value: "BZ", name: "بليزي" },
  { value: "BJ", name: "بنيني" },
  { value: "BT", name: "بوتاني" },
  { value: "BO", name: "بوليفي" },
  { value: "BA", name: "بوسني" },
  { value: "BW", name: "بوتسواني" },
  { value: "BR", name: "برازيلي" },
  { value: "BN", name: "بروني" },
  { value: "BG", name: "بلغاري" },
  { value: "BF", name: "بوركيني" },
  { value: "BI", name: "بوروندي" },
  { value: "CV", name: "رأس أخضري" },
  { value: "KH", name: "كمبودي" },
  { value: "CM", name: "كاميروني" },
  { value: "CA", name: "كندي" },
  { value: "CF", name: "أفريقي وسط" },
  { value: "TD", name: "تشادي" },
  { value: "CL", name: "تشيلي" },
  { value: "CN", name: "صيني" },
  { value: "CO", name: "كولومبي" },
  { value: "KM", name: "قمري" },
  { value: "CG", name: "كونغولي" },
  { value: "CD", name: "كونغولي ديمقراطي" },
  { value: "CR", name: "كوستاريكي" },
  { value: "CI", name: "عاجي" },
  { value: "HR", name: "كرواتي" },
  { value: "CU", name: "كوبي" },
  { value: "CY", name: "قبرصي" },
  { value: "CZ", name: "تشيكي" },
  { value: "DK", name: "دنماركي" },
  { value: "DJ", name: "جيبوتي" },
  { value: "DM", name: "دومينيكي" },
  { value: "DO", name: "دومينيكي" },
  { value: "EC", name: "إكوادوري" },
  { value: "EG", name: "مصري" },
  { value: "SV", name: "سلفادوري" },
  { value: "GQ", name: "غيني استوائي" },
  { value: "ER", name: "إريتري" },
  { value: "EE", name: "إستوني" },
  { value: "SZ", name: "إسواتيني" },
  { value: "ET", name: "إثيوبي" },
  { value: "FJ", name: "فيجي" },
  { value: "FI", name: "فنلندي" },
  { value: "FR", name: "فرنسي" },
  { value: "GA", name: "غابوني" },
  { value: "GM", name: "غامبي" },
  { value: "GE", name: "جورجي" },
  { value: "DE", name: "ألماني" },
  { value: "GH", name: "غاني" },
  { value: "GR", name: "يوناني" },
  { value: "GD", name: "غرينادي" },
  { value: "GT", name: "غواتيمالي" },
  { value: "GN", name: "غيني" },
  { value: "GW", name: "غيني بيساوي" },
  { value: "GY", name: "غياني" },
  { value: "HT", name: "هايتي" },
  { value: "HN", name: "هندوراسي" },
  { value: "HU", name: "مجري" },
  { value: "IS", name: "آيسلندي" },
  { value: "IN", name: "هندي" },
  { value: "ID", name: "إندونيسي" },
  { value: "IR", name: "إيراني" },
  { value: "IQ", name: "عراقي" },
  { value: "IE", name: "أيرلندي" },
  { value: "IL", name: "إسرائيلي" },
  { value: "IT", name: "إيطالي" },
  { value: "JM", name: "جامايكي" },
  { value: "JP", name: "ياباني" },
  { value: "JO", name: "أردني" },
  { value: "KZ", name: "كازاخستاني" },
  { value: "KE", name: "كيني" },
  { value: "KI", name: "كيريباتي" },
  { value: "KP", name: "كوري شمالي" },
  { value: "KR", name: "كوري جنوبي" },
  { value: "KW", name: "كويتي" },
  { value: "KG", name: "قيرغيزستاني" },
  { value: "LA", name: "لاوسي" },
  { value: "LV", name: "لاتفي" },
  { value: "LB", name: "لبناني" },
  { value: "LS", name: "ليسوتوي" },
  { value: "LR", name: "ليبيري" },
  { value: "LY", name: "ليبي" },
  { value: "LI", name: "ليختنشتايني" },
  { value: "LT", name: "ليتواني" },
  { value: "LU", name: "لوكسمبورغي" },
  { value: "MG", name: "مدغشقري" },
  { value: "MW", name: "ملاوي" },
  { value: "MY", name: "ماليزي" },
  { value: "MV", name: "مالديفي" },
  { value: "ML", name: "مالي" },
  { value: "MT", name: "مالطي" },
  { value: "MH", name: "مارشالي" },
  { value: "MR", name: "موريتاني" },
  { value: "MU", name: "موريشيوسي" },
  { value: "MX", name: "مكسيكي" },
  { value: "FM", name: "ميكرونيزي" },
  { value: "MD", name: "مولدوفي" },
  { value: "MC", name: "موناكي" },
  { value: "MN", name: "منغولي" },
  { value: "ME", name: "جبل أسودي" },
  { value: "MA", name: "مغربي" },
  { value: "MZ", name: "موزمبيقي" },
  { value: "MM", name: "ميانماري" },
  { value: "NA", name: "ناميبي" },
  { value: "NR", name: "ناوروي" },
  { value: "NP", name: "نيبالي" },
  { value: "NL", name: "هولندي" },
  { value: "NZ", name: "نيوزيلندي" },
  { value: "NI", name: "نيكاراغوي" },
  { value: "NE", name: "نيجري" },
  { value: "NG", name: "نيجيري" },
  { value: "MK", name: "مقدوني" },
  { value: "NO", name: "نرويجي" },
  { value: "OM", name: "عماني" },
  { value: "PK", name: "باكستاني" },
  { value: "PW", name: "بالاوي" },
  { value: "PS", name: "فلسطيني" },
  { value: "PA", name: "بنمي" },
  { value: "PG", name: "بابوي" },
  { value: "PY", name: "باراغواياني" },
  { value: "PE", name: "بيروفي" },
  { value: "PH", name: "فلبيني" },
  { value: "PL", name: "بولندي" },
  { value: "PT", name: "برتغالي" },
  { value: "QA", name: "قطري" },
  { value: "RO", name: "روماني" },
  { value: "RU", name: "روسي" },
  { value: "RW", name: "رواندي" },
  { value: "KN", name: "سانت كيتسي" },
  { value: "LC", name: "سانت لوسي" },
  { value: "VC", name: "سانت فنسنتي" },
  { value: "WS", name: "ساموي" },
  { value: "SM", name: "سان ماريني" },
  { value: "ST", name: "ساو تومي" },
  { value: "SA", name: "سعودي" },
  { value: "SN", name: "سنغالي" },
  { value: "RS", name: "صربي" },
  { value: "SC", name: "سيشلي" },
  { value: "SL", name: "سيراليوني" },
  { value: "SG", name: "سنغافوري" },
  { value: "SK", name: "سلوفاكي" },
  { value: "SI", name: "سلوفيني" },
  { value: "SB", name: "سليماني" },
  { value: "SO", name: "صومالي" },
  { value: "ZA", name: "جنوب أفريقي" },
  { value: "SS", name: "جنوب سوداني" },
  { value: "ES", name: "إسباني" },
  { value: "LK", name: "سريلانكي" },
  { value: "SD", name: "سوداني" },
  { value: "SR", name: "سورينامي" },
  { value: "SE", name: "سويدي" },
  { value: "CH", name: "سويسري" },
  { value: "SY", name: "سوري" },
  { value: "TW", name: "تايواني" },
  { value: "TJ", name: "طاجيكستاني" },
  { value: "TZ", name: "تنزاني" },
  { value: "TH", name: "تايلندي" },
  { value: "TL", name: "تيموري" },
  { value: "TG", name: "توغي" },
  { value: "TO", name: "تونغي" },
  { value: "TT", name: "ترينيدادي" },
  { value: "TN", name: "تونسي" },
  { value: "TR", name: "تركي" },
  { value: "TM", name: "تركمانستاني" },
  { value: "TV", name: "توفالي" },
  { value: "UG", name: "أوغندي" },
  { value: "UA", name: "أوكراني" },
  { value: "AE", name: "إماراتي" },
  { value: "GB", name: "بريطاني" },
  { value: "US", name: "أمريكي" },
  { value: "UY", name: "أوروغواياني" },
  { value: "UZ", name: "أوزبكستاني" },
  { value: "VU", name: "فانواتي" },
  { value: "VA", name: "فاتيكاني" },
  { value: "VE", name: "فنزويلي" },
  { value: "VN", name: "فيتنامي" },
  { value: "YE", name: "يمني" },
  { value: "ZM", name: "زامبي" },
  { value: "ZW", name: "زيمبابوي" },
];

// Complete Country Calling Codes (All 195+ Countries)
export const COUNTRY_CODES = [
  { value: "93", name: "+93" },
  { value: "355", name: "+355" },
  { value: "213", name: "+213" },
  { value: "1684", name: "+1684" },
  { value: "376", name: "+376" },
  { value: "244", name: "+244" },
  { value: "1264", name: "+1264" },
  { value: "672", name: "+672" },
  { value: "1268", name: "+1268" },
  { value: "54", name: "+54" },
  { value: "374", name: "+374" },
  { value: "297", name: "+297" },
  { value: "61", name: "+61" },
  { value: "43", name: "+43" },
  { value: "994", name: "+994" },
  { value: "1242", name: "+1242" },
  { value: "973", name: "+973" },
  { value: "880", name: "+880" },
  { value: "1246", name: "+1246" },
  { value: "375", name: "+375" },
  { value: "32", name: "+32" },
  { value: "501", name: "+501" },
  { value: "229", name: "+229" },
  { value: "1441", name: "+1441" },
  { value: "975", name: "+975" },
  { value: "591", name: "+591" },
  { value: "387", name: "+387" },
  { value: "267", name: "+267" },
  { value: "55", name: "+55" },
  { value: "246", name: "+246" },
  { value: "673", name: "+673" },
  { value: "359", name: "+359" },
  { value: "226", name: "+226" },
  { value: "257", name: "+257" },
  { value: "855", name: "+855" },
  { value: "237", name: "+237" },
  { value: "1", name: "+1" },
  { value: "238", name: "+238" },
  { value: "1345", name: "+1345" },
  { value: "236", name: "+236" },
  { value: "235", name: "+235" },
  { value: "56", name: "+56" },
  { value: "86", name: "+86" },
  { value: "57", name: "+57" },
  { value: "269", name: "+269" },
  { value: "242", name: "+242" },
  { value: "243", name: "+243" },
  { value: "682", name: "+682" },
  { value: "506", name: "+506" },
  { value: "225", name: "+225" },
  { value: "385", name: "+385" },
  { value: "53", name: "+53" },
  { value: "357", name: "+357" },
  { value: "420", name: "+420" },
  { value: "45", name: "+45" },
  { value: "253", name: "+253" },
  { value: "1767", name: "+1767" },
  { value: "1809", name: "+1809" },
  { value: "593", name: "+593" },
  { value: "20", name: "+20" },
  { value: "503", name: "+503" },
  { value: "240", name: "+240" },
  { value: "291", name: "+291" },
  { value: "372", name: "+372" },
  { value: "251", name: "+251" },
  { value: "500", name: "+500" },
  { value: "298", name: "+298" },
  { value: "679", name: "+679" },
  { value: "358", name: "+358" },
  { value: "33", name: "+33" },
  { value: "594", name: "+594" },
  { value: "689", name: "+689" },
  { value: "241", name: "+241" },
  { value: "220", name: "+220" },
  { value: "995", name: "+995" },
  { value: "49", name: "+49" },
  { value: "233", name: "+233" },
  { value: "350", name: "+350" },
  { value: "30", name: "+30" },
  { value: "299", name: "+299" },
  { value: "1473", name: "+1473" },
  { value: "590", name: "+590" },
  { value: "1671", name: "+1671" },
  { value: "502", name: "+502" },
  { value: "224", name: "+224" },
  { value: "245", name: "+245" },
  { value: "592", name: "+592" },
  { value: "509", name: "+509" },
  { value: "379", name: "+379" },
  { value: "504", name: "+504" },
  { value: "852", name: "+852" },
  { value: "36", name: "+36" },
  { value: "354", name: "+354" },
  { value: "91", name: "+91" },
  { value: "62", name: "+62" },
  { value: "98", name: "+98" },
  { value: "964", name: "+964" },
  { value: "353", name: "+353" },
  { value: "972", name: "+972" },
  { value: "39", name: "+39" },
  { value: "1876", name: "+1876" },
  { value: "81", name: "+81" },
  { value: "962", name: "+962" },
  { value: "7", name: "+7" },
  { value: "254", name: "+254" },
  { value: "686", name: "+686" },
  { value: "850", name: "+850" },
  { value: "82", name: "+82" },
  { value: "965", name: "+965" },
  { value: "996", name: "+996" },
  { value: "856", name: "+856" },
  { value: "371", name: "+371" },
  { value: "961", name: "+961" },
  { value: "266", name: "+266" },
  { value: "231", name: "+231" },
  { value: "218", name: "+218" },
  { value: "423", name: "+423" },
  { value: "370", name: "+370" },
  { value: "352", name: "+352" },
  { value: "853", name: "+853" },
  { value: "389", name: "+389" },
  { value: "261", name: "+261" },
  { value: "265", name: "+265" },
  { value: "60", name: "+60" },
  { value: "960", name: "+960" },
  { value: "223", name: "+223" },
  { value: "356", name: "+356" },
  { value: "692", name: "+692" },
  { value: "596", name: "+596" },
  { value: "222", name: "+222" },
  { value: "230", name: "+230" },
  { value: "262", name: "+262" },
  { value: "52", name: "+52" },
  { value: "691", name: "+691" },
  { value: "373", name: "+373" },
  { value: "377", name: "+377" },
  { value: "976", name: "+976" },
  { value: "1664", name: "+1664" },
  { value: "212", name: "+212" },
  { value: "258", name: "+258" },
  { value: "95", name: "+95" },
  { value: "264", name: "+264" },
  { value: "674", name: "+674" },
  { value: "977", name: "+977" },
  { value: "31", name: "+31" },
  { value: "599", name: "+599" },
  { value: "687", name: "+687" },
  { value: "64", name: "+64" },
  { value: "505", name: "+505" },
  { value: "227", name: "+227" },
  { value: "234", name: "+234" },
  { value: "683", name: "+683" },
  { value: "672", name: "+672" },
  { value: "1670", name: "+1670" },
  { value: "47", name: "+47" },
  { value: "968", name: "+968" },
  { value: "92", name: "+92" },
  { value: "680", name: "+680" },
  { value: "970", name: "+970" },
  { value: "507", name: "+507" },
  { value: "675", name: "+675" },
  { value: "595", name: "+595" },
  { value: "51", name: "+51" },
  { value: "63", name: "+63" },
  { value: "48", name: "+48" },
  { value: "351", name: "+351" },
  { value: "1939", name: "+1939" },
  { value: "974", name: "+974" },
  { value: "40", name: "+40" },
  { value: "7", name: "+7" },
  { value: "250", name: "+250" },
  { value: "290", name: "+290" },
  { value: "1869", name: "+1869" },
  { value: "1758", name: "+1758" },
  { value: "508", name: "+508" },
  { value: "1784", name: "+1784" },
  { value: "685", name: "+685" },
  { value: "378", name: "+378" },
  { value: "239", name: "+239" },
  { value: "966", name: "+966" },
  { value: "221", name: "+221" },
  { value: "381", name: "+381" },
  { value: "248", name: "+248" },
  { value: "232", name: "+232" },
  { value: "65", name: "+65" },
  { value: "421", name: "+421" },
  { value: "386", name: "+386" },
  { value: "677", name: "+677" },
  { value: "252", name: "+252" },
  { value: "27", name: "+27" },
  { value: "500", name: "+500" },
  { value: "34", name: "+34" },
  { value: "94", name: "+94" },
  { value: "249", name: "+249" },
  { value: "597", name: "+597" },
  { value: "47", name: "+47" },
  { value: "268", name: "+268" },
  { value: "46", name: "+46" },
  { value: "41", name: "+41" },
  { value: "963", name: "+963" },
  { value: "886", name: "+886" },
  { value: "992", name: "+992" },
  { value: "255", name: "+255" },
  { value: "66", name: "+66" },
  { value: "228", name: "+228" },
  { value: "690", name: "+690" },
  { value: "676", name: "+676" },
  { value: "1868", name: "+1868" },
  { value: "216", name: "+216" },
  { value: "90", name: "+90" },
  { value: "993", name: "+993" },
  { value: "1649", name: "+1649" },
  { value: "688", name: "+688" },
  { value: "256", name: "+256" },
  { value: "380", name: "+380" },
  { value: "971", name: "+971" },
  { value: "44", name: "+44" },
  { value: "1", name: "+1" },
  { value: "598", name: "+598" },
  { value: "998", name: "+998" },
  { value: "678", name: "+678" },
  { value: "58", name: "+58" },
  { value: "84", name: "+84" },
  { value: "1284", name: "+1284" },
  { value: "1340", name: "+1340" },
  { value: "681", name: "+681" },
  { value: "212", name: "+212" },
  { value: "967", name: "+967" },
  { value: "260", name: "+260" },
  { value: "263", name: "+263" },
];
export const mobileCodeToCountryMap = {
  "+1": "US",
  "+7": "RU",
  "+20": "EG",
  "+27": "ZA",
  "+30": "GR",
  "+31": "NL",
  "+32": "BE",
  "+33": "FR",
  "+34": "ES",
  "+36": "HU",
  "+39": "IT",
  "+40": "RO",
  "+41": "CH",
  "+43": "AT",
  "+44": "GB",
  "+45": "DK",
  "+46": "SE",
  "+47": "NO",
  "+48": "PL",
  "+49": "DE",
  "+51": "PE",
  "+52": "MX",
  "+53": "CU",
  "+54": "AR",
  "+55": "BR",
  "+56": "CL",
  "+57": "CO",
  "+58": "VE",
  "+60": "MY",
  "+61": "AU",
  "+62": "ID",
  "+63": "PH",
  "+64": "NZ",
  "+65": "SG",
  "+66": "TH",
  "+81": "JP",
  "+82": "KR",
  "+84": "VN",
  "+86": "CN",
  "+90": "TR",
  "+91": "IN",
  "+92": "PK",
  "+93": "AF",
  "+94": "LK",
  "+95": "MM",
  "+98": "IR",
  "+211": "SS",
  "+212": "MA",
  "+213": "DZ",
  "+216": "TN",
  "+218": "LY",
  "+220": "GM",
  "+221": "SN",
  "+222": "MR",
  "+223": "ML",
  "+224": "GN",
  "+225": "CI",
  "+226": "BF",
  "+227": "NE",
  "+228": "TG",
  "+229": "BJ",
  "+230": "MU",
  "+231": "LR",
  "+232": "SL",
  "+233": "GH",
  "+234": "NG",
  "+235": "TD",
  "+236": "CF",
  "+237": "CM",
  "+238": "CV",
  "+239": "ST",
  "+240": "GQ",
  "+241": "GA",
  "+242": "CG",
  "+243": "CD",
  "+244": "AO",
  "+245": "GW",
  "+248": "SC",
  "+249": "SD",
  "+250": "RW",
  "+251": "ET",
  "+252": "SO",
  "+253": "DJ",
  "+254": "KE",
  "+255": "TZ",
  "+256": "UG",
  "+257": "BI",
  "+258": "MZ",
  "+260": "ZM",
  "+261": "MG",
  "+262": "RE",
  "+263": "ZW",
  "+264": "NA",
  "+265": "MW",
  "+266": "LS",
  "+267": "BW",
  "+268": "SZ",
  "+269": "KM",
  "+290": "SH",
  "+291": "ER",
  "+297": "AW",
  "+298": "FO",
  "+299": "GL",
  "+350": "GI",
  "+351": "PT",
  "+352": "LU",
  "+353": "IE",
  "+354": "IS",
  "+355": "AL",
  "+356": "MT",
  "+357": "CY",
  "+358": "FI",
  "+359": "BG",
  "+370": "LT",
  "+371": "LV",
  "+372": "EE",
  "+373": "MD",
  "+374": "AM",
  "+375": "BY",
  "+376": "AD",
  "+377": "MC",
  "+378": "SM",
  "+379": "VA",
  "+380": "UA",
  "+381": "RS",
  "+382": "ME",
  "+383": "XK",
  "+385": "HR",
  "+386": "SI",
  "+387": "BA",
  "+389": "MK",
  "+420": "CZ",
  "+421": "SK",
  "+423": "LI",
  "+500": "FK",
  "+501": "BZ",
  "+502": "GT",
  "+503": "SV",
  "+504": "HN",
  "+505": "NI",
  "+506": "CR",
  "+507": "PA",
  "+508": "PM",
  "+509": "HT",
  "+590": "GP",
  "+591": "BO",
  "+592": "GY",
  "+593": "EC",
  "+594": "GF",
  "+595": "PY",
  "+596": "MQ",
  "+597": "SR",
  "+598": "UY",
  "+670": "TL",
  "+672": "NF",
  "+673": "BN",
  "+674": "NR",
  "+675": "PG",
  "+676": "TO",
  "+677": "SB",
  "+678": "VU",
  "+679": "FJ",
  "+680": "PW",
  "+681": "WF",
  "+682": "CK",
  "+683": "NU",
  "+685": "WS",
  "+686": "KI",
  "+687": "NC",
  "+688": "TV",
  "+689": "PF",
  "+690": "TK",
  "+691": "FM",
  "+692": "MH",
  "+850": "KP",
  "+852": "HK",
  "+853": "MO",
  "+855": "KH",
  "+856": "LA",
  "+880": "BD",
  "+886": "TW",
  "+960": "MV",
  "+961": "LB",
  "+962": "JO",
  "+963": "SY",
  "+964": "IQ",
  "+965": "KW",
  "+966": "SA",
  "+967": "YE",
  "+968": "OM",
  "+970": "PS",
  "+971": "AE",
  "+972": "PS",
  "+973": "BH",
  "+974": "QA",
  "+975": "BT",
  "+976": "MN",
  "+977": "NP",
  "+992": "TJ",
  "+993": "TM",
  "+994": "AZ",
  "+995": "GE",
  "+996": "KG",
  "+998": "UZ",
  "+1242": "BS",
  "+1246": "BB",
  "+1264": "AI",
  "+1268": "AG",
  "+1284": "VG",
  "+1340": "VI",
  "+1345": "KY",
  "+1441": "BM",
  "+1473": "GD",
  "+1649": "TC",
  "+1664": "MS",
  "+1670": "MP",
  "+1671": "GU",
  "+1684": "AS",
  "+1758": "LC",
  "+1767": "DM",
  "+1784": "VC",
  "+1787": "PR",
  "+1809": "DO",
  "+1869": "KN",
  "+1876": "JM",
  "+1868": "TT",
};

// Validation patterns for different country codes
export const mobilePatterns = {
  "+966": /^5[0-9]{8}$/, // Saudi Arabia: 9 digits starting with 5
  "+971": /^5[0-9]{8}$/, // UAE: 9 digits starting with 5
  "+965": /^[569][0-9]{7}$/, // Kuwait: 8 digits starting with 5,6,9
  "+974": /^[357][0-9]{7}$/, // Qatar: 8 digits starting with 3,5,7
  "+973": /^[36][0-9]{7}$/, // Bahrain: 8 digits starting with 3,6
  "+968": /^[79][0-9]{7}$/, // Oman: 8 digits starting with 7,9
  "+20": /^1[0-9]{9}$/, // Egypt: 10 digits starting with 1
  "+212": /^[67][0-9]{8}$/, // Morocco: 9 digits starting with 6,7
  "+213": /^[567][0-9]{8}$/, // Algeria: 9 digits starting with 5,6,7
  "+216": /^[259][0-9]{7}$/, // Tunisia: 8 digits starting with 2,5,9
  "+218": /^9[0-9]{8}$/, // Libya: 9 digits starting with 9
  "+249": /^9[0-9]{8}$/, // Sudan: 9 digits starting with 9
  "+962": /^7[789][0-9]{7}$/, // Jordan: 9 digits starting with 77,78,79
  "+961": /^[37][0-9]{7}$/, // Lebanon: 8 digits starting with 3,7
  "+963": /^9[0-9]{8}$/, // Syria: 9 digits starting with 9
  "+964": /^7[0-9]{9}$/, // Iraq: 10 digits starting with 7
  "+90": /^5[0-9]{9}$/, // Turkey: 10 digits starting with 5
  "+98": /^9[0-9]{9}$/, // Iran: 10 digits starting with 9
  "+92": /^3[0-9]{9}$/, // Pakistan: 10 digits starting with 3
  "+91": /^[6-9][0-9]{9}$/, // India: 10 digits starting with 6-9
  "+86": /^1[3-9][0-9]{9}$/, // China: 11 digits starting with 1
  "+81": /^[789][0-9]{9}$/, // Japan: 10 digits starting with 7,8,9
  "+82": /^1[0-9]{8}$/, // South Korea: 9 digits starting with 1
  "+1": /^[2-9][0-9]{9}$/, // US/Canada: 10 digits starting with 2-9
  "+44": /^7[0-9]{9}$/, // UK: 10 digits starting with 7
  "+33": /^[67][0-9]{8}$/, // France: 9 digits starting with 6,7
  "+49": /^1[5-7][0-9]{8}$/, // Germany: 10 digits starting with 15,16,17
  "+39": /^3[0-9]{9}$/, // Italy: 10 digits starting with 3
  "+34": /^[67][0-9]{8}$/, // Spain: 9 digits starting with 6,7
  "+7": /^[79][0-9]{9}$/, // Russia: 10 digits starting with 7,9
  "+55": /^[1-9][0-9]{10}$/, // Brazil: 11 digits starting with 1-9
  "+61": /^4[0-9]{8}$/, // Australia: 9 digits starting with 4
  "+27": /^[67][0-9]{8}$/, // South Africa: 9 digits starting with 6,7
  "+234": /^[789][0-9]{9}$/, // Nigeria: 10 digits starting with 7,8,9
  "+254": /^[17][0-9]{8}$/, // Kenya: 9 digits starting with 1,7
  "+256": /^[789][0-9]{8}$/, // Uganda: 9 digits starting with 7,8,9
  "+255": /^[67][0-9]{8}$/, // Tanzania: 9 digits starting with 6,7
  "+251": /^9[0-9]{8}$/, // Ethiopia: 9 digits starting with 9
};
